/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Error_Shop_Category_In_UseInputs */

const vi_error_shop_category_in_use = /** @type {(inputs: Error_Shop_Category_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Danh mục đang được ${i?.count} nhóm dùng — gỡ khỏi các nhóm đó trước, hoặc tắt hiện web / Mini App.`)
};

/**

* @param {Error_Shop_Category_In_UseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_category_in_use = /** @type {((inputs: Error_Shop_Category_In_UseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Category_In_UseInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_category_in_use(inputs)
});